import React from "react";
import { useSnapshot } from "valtio";
import classnames from "classnames";
import { useTranslation } from "react-i18next/";
import { toast } from "react-toastify";
import { VerticalDotsIcon } from "@aureskonnect/react-ui";
import { uuid } from "uuidv4";

import store, {
    setKey,
    setActions,
    setIsActionsClicked,
    setIsEdited,
} from "../store";
import { store as ModeOfSale } from "../../../../components/VerticalLayout/store";

import ErrorToast from "@components/Common/ErrorTost";
import { ConfirmationArchive } from "../ConfirmationArchive";
import {
    archiveModeOfSaleFranchise,
    archiveModeSale,
    associateModeOfSale,
    createModeOfSaleData,
    isModeOfSaleExist,
} from "./hooks";
import { showSuccessToast } from "@components/Common/SuccessToast";
import { useFetchGlobal } from "../../../../api/hooks";
import { isSaleSupportArchived } from "./urls";

export function ActionColumnModeSale({
    selectedRows,
    setDataIsUpdated,
    isModeOfSaleArchived,
    setIsModeOfSaleArchived,
    setLimit,
    setSelectedRows,
    setModalState,
}: any) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();

    const {
        numberArchived,
        numberActive,
        shopsModeSaleData,
        archivedModeOfSaleFranchise,
        isEdited,
        isActionsClicked,
        modify,
        isLoading,
    } = useSnapshot(store);
    const { franchiseID, oneShop, userID, operatorID, shopID } = useSnapshot(
        ModeOfSale
    );
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");
    const [isArchiveModalOpened, setIsArchiveModalOpened] = React.useState<
        boolean
    >(false);
    const [listSaleMode] = React.useState<any>([]);
    const shopId = oneShop ? shopID : 0;
    let dataAssociate: any[] = [];
    let dataArchive: any[] = [];

    if (!oneShop) {
        dataAssociate = associateModeOfSale(shopsModeSaleData);
        dataArchive = archiveModeSale(shopsModeSaleData);
    } else {
        dataArchive = archiveModeOfSaleFranchise(archivedModeOfSaleFranchise);
    }

    async function activeModeOfSale() {
        toast.dismiss();
        let localData: any[] = [];

        for (let el of selectedRows) {
            let dataModeOfSale = createModeOfSaleData(
                el,
                userID,
                franchiseID,
                operatorID,
                uuidUser
            );
            localData.push(dataModeOfSale);
        }
        try {
            await fetchGlobal<any>(
                `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_sale`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(localData),
                }
            );
            showSuccessToast(
                `${t("Sales method has been successfully activated")!}`
            );
            setDataIsUpdated!(true);
            setKey(uuid());
        } catch (e) {
            ErrorToast(`${t("There's an error")!}`);
        }
    }

    return (
        <React.Fragment>
            <div>
                <div className="dropdown">
                    <VerticalDotsIcon
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        style={{ cursor: "pointer" }}
                        height={25}
                        width={25}
                        fill="black"
                        className="cmn_drp_FRmenu"
                    />
                    <div
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                    >
                        <div
                            className="dropdown-item pl-1"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                if (isEdited === true) {
                                    setIsActionsClicked(!isActionsClicked);
                                    setActions(() => {
                                        setIsEdited(false);
                                        setModalState((prev: any) => ({
                                            ...prev,
                                            isAddModeOfSaleClicked: false,
                                        }));
                                        setIsModeOfSaleArchived(false);
                                    });
                                } else {
                                    setIsModeOfSaleArchived(false);
                                }
                            }}
                        >
                            <span className="ml-2 cmn_btn_FRlistActivated">
                                {t("Sales method activated(s)")}({numberActive})
                            </span>
                        </div>
                        <div
                            className="dropdown-item pl-1"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                if (isEdited === true) {
                                    setIsActionsClicked(!isActionsClicked);
                                    setActions(() => {
                                        setIsEdited(false);

                                        setIsModeOfSaleArchived(true);
                                        setModalState((prev: any) => ({
                                            ...prev,
                                            isAddModeOfSaleClicked: false,
                                        }));
                                    });
                                } else {
                                    setIsModeOfSaleArchived(true);
                                    setModalState((prev: any) => ({
                                        ...prev,
                                        isAddModeOfSaleClicked: false,
                                    }));
                                }
                            }}
                        >
                            <span className="ml-2 cmn_btn_FRlistArchived">
                                {t("Sales method archived(s)")}({numberArchived}
                                )
                            </span>
                        </div>
                        <div
                            style={{ cursor: "pointer" }}
                            className={`${classnames(
                                " dropdown-item pl-1 pointer__clz mdv_btn_FRhistoric",
                                {
                                    "not-allowed-icon__clz":
                                        selectedRows.length === 0,
                                }
                            )}`}
                            onClick={() => {
                                if (isEdited === true) {
                                    setIsActionsClicked(!isActionsClicked);
                                    setActions(() => {
                                        setIsEdited(false);

                                        if (selectedRows.length === 1) {
                                            ErrorToast(
                                                `${t(
                                                    "Attention, it is a multiple action. Please select at least two items"
                                                )!}`
                                            );
                                        } else {
                                            setModalState((prev: any) => ({
                                                ...prev,
                                                isHistoryModalOpened: true,
                                            }));
                                        }
                                        setModalState((prev: any) => ({
                                            ...prev,
                                            isAddModeOfSaleClicked: false,
                                        }));
                                    });
                                } else {
                                    if (selectedRows.length === 1) {
                                        ErrorToast(
                                            `${t(
                                                "Attention, it is a multiple action. Please select at least two items"
                                            )!}`
                                        );
                                    } else {
                                        setModalState((prev: any) => ({
                                            ...prev,
                                            isHistoryModalOpened: true,
                                        }));
                                    }
                                }
                            }}
                        >
                            <span className="ml-2 cmn_btn_FRhistory">
                                {t("Historical")}
                            </span>
                        </div>
                        {modify === true ? (
                            <>
                                <div
                                    style={{ cursor: "pointer" }}
                                    className={`${classnames(
                                        " dropdown-item pl-1 pointer__clz",
                                        {
                                            "not-allowed-icon__clz":
                                                isLoading ||
                                                selectedRows.length === 0 ||
                                                (isModeOfSaleArchived &&
                                                    oneShop &&
                                                    selectedRows.some(
                                                        (element: any) =>
                                                            dataArchive.includes(
                                                                element.Id
                                                            )
                                                    )),
                                        }
                                    )}`}
                                    onClick={async () => {
                                        let isArchived = await isSaleSupportArchived(
                                            userID,
                                            shopId,
                                            franchiseID,
                                            selectedRows,
                                            i18nextLng,
                                            fetchGlobal
                                        );

                                        if (selectedRows.length === 1) {
                                            ErrorToast(
                                                `${t(
                                                    "Attention, it is a multiple action. Please select at least two items"
                                                )!}`
                                            );
                                        } else if (
                                            isArchived === true &&
                                            isModeOfSaleArchived
                                        ) {
                                            ErrorToast(
                                                `${t(
                                                    "Please note that  the unarchiving process could not be successfully completed. Please check the settings of the store(s) data."
                                                )!}`
                                            );
                                        } else {
                                            isModeOfSaleArchived
                                                ? selectedRows.some(
                                                      (element: any) =>
                                                          dataArchive.includes(
                                                              element.Id
                                                          )
                                                  ) && !oneShop
                                                    ? setModalState(
                                                          (prev: any) => ({
                                                              ...prev,
                                                              isModalOpened: true,
                                                          })
                                                      )
                                                    : activeModeOfSale()
                                                : isModeOfSaleExist(
                                                      selectedRows,
                                                      dataAssociate,
                                                      setIsArchiveModalOpened
                                                  );
                                        }
                                    }}
                                >
                                    <span className="ml-2 cmn_btn_FRarchived cmn_btn_FRunarchive">
                                        {isModeOfSaleArchived
                                            ? t("unarchive")
                                            : t("archive")}
                                    </span>
                                </div>
                            </>
                        ) : null}
                    </div>
                </div>
            </div>
            {isArchiveModalOpened ? (
                <ConfirmationArchive
                    isModalOpened={isArchiveModalOpened}
                    setIsModalOpened={setIsArchiveModalOpened}
                    setDataIsUpdated={setDataIsUpdated}
                    selectedRows={selectedRows}
                    setLimit={setLimit}
                    listSaleMode={listSaleMode}
                    setSelectedRows={setSelectedRows}
                />
            ) : null}
        </React.Fragment>
    );
}
